import {Service} from "../Axios/Service";
import { NewService } from "../Axios/Service";
import qs from "qs";
import store from "../../store";

const PROFILE = {
    order: "VUE_APP_ORDER_PREFIX",
};

function getType(apiType) {
    return process.env[PROFILE[apiType]];
}

class OrderApi {
    constructor(ApiType) {
        this.ApiType = ApiType;
    }
    //获取免责条款列表
    getOrderRemarkList() {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderRemark/list`,
            method: "get",
        });
    }
    queryCustomSelectResource(orderChildrenId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/procureOrder/queryCustomSelectResource?orderChildrenId=${orderChildrenId}`,
            method: "get",
        });
    }

    orderDetail(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/seeOrderDetail?childrenId=${id}`,
            method: "get",
        });
    }

    createOrderByStockIds(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderCreate/createOrderByStockIds`,
            method: "post",
            data: data,
        });
    }

    orderPayRequestApplyDai(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderList/orderPayRequestApplyDai`,
            method: "post",
            data: qs.stringify({requestNumber: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    orderPayRequestList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderList/orderPayRequestList`,
            method: "post",
            data: obj,
        });
    }

    //订单创建
    createOrderByInquiry(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderCreate/createOrderByInquiry`,
            method: "post",
            data: data,
        });
    }

    //客户下单及利润列表
    orderProfitSharing(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/admin/orderPlan/orderProfitSharing`,
            method: "post",
            data,
        });
    }

    //统计
    planList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderPlan/planList`,
            method: "post",
            data,
        });
    }

    querySurePlanByOrderMainId(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/plat/surePlan/querySurePlanByOrderMainId?orderMainId=${id}`,
            method: "post",
        });
    }

    //订单发送接口
    purchaseOrderId(cildrenId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderCreate/createOrderByPurchaseOrder?purchaseOrderId=${cildrenId}`,
            method: "post",
        });
    }

    //付款后的订单取消
    orderHasBeenPaidAndCancelled(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/orderHasBeenPaidAndCancelled`,
            method: "post",
            data: qs.stringify({childrenId: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    platformConfirmsBudgetResources(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/supplierAppletOrderChildren/platformConfirmsBudgetResources`,
            method: "post",
            data,
        });
    }

    //与商家沟通取消费用
    merchantCommunication(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/merchantCommunication`,
            method: "post",
            data: data,
        });
    }

    //付款后的订单部分取消
    orderPartHasBeenPaidAndCancelled(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/orderPartHasBeenPaidAndCancelled/${data[0].orderChildrenId}`,
            method: "post",
            data: data,
        });
    }

    //付款后的订单部分取消另一种情况
    orderPartHasBeenPaidAndCancelled1(orderChildrenId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/orderPartHasBeenPaidAndCancelled/${orderChildrenId}`,
            method: "post",
            data: [],
        });
    }

    //订单取消
    paidModifyOrderCancel(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderModify/paidModifyOrderCancel`,
            method: "post",
            data: data,
        });
    }

    //订单取消发送接口
    orderCancelSending(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/orderProfitInquiry/cancelSending`,
            method: "post",
            data: data,
        });
    }

    //修改减少数量(订单确认后变更)
    modifyOrderCancel(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderModify/modifyOrderCancel`,
            method: "post",
            data: data,
        });
    }

    //修改订单详情
    modifyOrderDetail(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderModify/modifyDetail`,
            method: "post",
            data: data,
        });
    }

    //通过订单编号查询供应商信息
    supplierInformation(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/orderList/supplierInformation`,
            method: "post",
            data: qs.stringify({orderId: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    orderUnpaidCancellation(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/orderUnpaidCancellation`,
            method: "post",
            data: qs.stringify({childrenId: id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //自己的订单列表(我的支出) 下的订单类型的订单数量
    orderType() {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/orderList/orderType`,
            method: "post",
            data: {},
        });
    }

    //自己的订单列表(我的支出)
    myExpenses(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/orderList/pageList`,
            method: "post",
            data: data,
        });
    }

    //订单状态说明
    statusDescription(id) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/platApi/orderList/statusDescription`,
            method: "post",
            data: qs.stringify({id}),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    createOrder(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderCreate/create`,
            // url: `http://localhost:9500/wintac-order-web-test-tw/api/orderCreate/create`,
            method: "post",
            data: obj,
        });
    }

    isOrdered(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderCreate/isOrdered`,
            method: "post",
            data: obj,
        });
    }

    sendPayCode() {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderCreate/sendPayCode`,
            method: "post",
            data: {},
        });
    }

    orderPreShow(budgetIds, value) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderPre/show/${value}`,
            method: "post",
            data: budgetIds,
        });
    }

    querySurePlan(budgetIds) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/plat/surePlan/querySurePlan`,
            method: "post",
            data: budgetIds,
        });
    }

    surePlanAddOrUpdate(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/plat/surePlan/surePlanAddOrUpdate`,
            method: "post",
            data,
        });
    }

    inventoryPolicyDisplay(policyDisplayRequests) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderPre/inventoryPolicyDisplay`,
            method: "post",
            data: policyDisplayRequests,
        });
    }

    //自己的子订单
    platOrderList(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderList/platOrderList`,
            method: "post",
            data: obj,
        });
    }

    //调整订单及金额
    adjustingOrdersAndAmounts(arr, cildrenId) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/modifyOrderPrice/${cildrenId}`,
            method: "post",
            data: arr,
        });
    }

    //客户的子订单
    platCustomerOrderList(obj) {
        return NewService({
            url: `/customizerWeb/v1/order/platCustomerOrderList`,
            method: "post",
            data: obj,
        });
    }

    //行程详情
    budgetList(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderPlan/budgetList`,
            method: "post",
            data: qs.stringify(data),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //行程详情
    planDetail(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderPlan/planDetail`,
            method: "post",
            data: qs.stringify(data),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //订单评价模版列表
    evaluationTemplate(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/evaluateTemplate/pageList`,
            method: "post",
            data: obj,
        });
    }

    //模版保存或修改
    saveOrUpdate(obj) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/evaluateTemplate/saveOrUpdate`,
            method: "post",
            data: obj,
        });
    }

    //通过label查询对应的模版数据
    examineeEvaluationTemplate(label) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/evaluateTemplate/queryOne?label=${label}`,
            method: "get",
        });
    }

    //采购订单下单接口
    // purchaseOrderId(cildrenId) {
    //     let apiType = getType(this.ApiType);
    //     return Service({
    //         url: `/${apiType}/api/orderCreate/createOrderByPurchaseOrder?purchaseOrderId=${cildrenId}`,
    //         method: "post",
    //     });
    // }

    //applyConfigId为19
    walletBalance(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/walletBalance`,
            method: "post",
            data: qs.stringify(data),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //applyConfigId为20
    paymentOfGroupSpecialFunds(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/paymentOfGroupSpecialFunds`,
            method: "post",
            data: qs.stringify(data),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }

    //applyConfigId为21
    balanceOfSpecialFunds(data) {
        let apiType = getType(this.ApiType);
        return Service({
            url: `/${apiType}/api/orderChildren/balanceOfSpecialFunds`,
            method: "post",
            data: qs.stringify(data),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    }
}

export default OrderApi;


let orderData = {
    //资源信息
    resourceInfo:{
        addressCn:'',
        address: "rue 6, paris, france",
        cityNameCn:'巴黎',//cityNameCn没值渲染cityName
        cityName:'Paris',
        imageUrl:'',//资源图片 没值默认给个资源图片
    },
    //政策
    modifyOrderCancelResult: {
        cancelTotalPrice: 0,
        refundableTotalAmount: 34642.62,//退款金额，待支付的情况下不显示，
        modifyOrderCancelDetailResultList: [
            {
                cancellationPolicyDescription: "该订单已有供应商确认,且已不在免费取消期内,<b>若您此时取消将会产生取消费用</b>,取消政策如下：(按入住前30天可取消订单金额的100%",
                productName: 'Twin Room',
                stockInfo: [
                    {
                        "name": "预定说明",
                        "value": [
                            {
                                "name": "是否可拆分购买",
                                "value": "否"
                            },
                            {
                                "name": "上架有效期",
                                "value": "2025-03-21 00:00"
                            }
                        ]
                    },
                    {
                        "name": "费用说明",
                        "value": [
                            {
                                "name": "是否含VAT",
                                "value": "是"
                            },
                            {
                                "name": "是否含城市税",
                                "value": "否8.13/人"
                            },
                            {
                                "name": "报价含早餐",
                                "value": "2份"
                            }
                        ]
                    },
                    {
                        "name": "使用说明",
                        "value": [
                            {
                                "name": "抵达酒店后",
                                "value": "用您的预定时提供的证件 以及 voucher (预定凭证) 即可入驻"
                            }
                        ]
                    },
                    {
                        "name": "退改说明",
                        "value": [
                            {
                                "name": "退改政策",
                                "value": "有条件取消"
                            },
                            {
                                "name": "",
                                "value": "使用前30天18:00可免费取消100%"
                            }
                        ]
                    }
                ]
            },
            {
                "cancellationPolicyDescription": "该订单已有供应商确认,且已不在免费取消期内,<b>若您此时取消将会产生取消费用</b>,取消政策如下：(按入住前30天可取消订单金额的100%",
                "productName": "城市税",
                "stockInfo": [
                    {
                        "name": "预定说明",
                        "value": [
                            {
                                "name": "是否可拆分购买",
                                "value": "否"
                            },
                            {
                                "name": "上架有效期",
                                "value": "2025-03-21 00:00"
                            }
                        ]
                    },
                    {
                        "name": "费用说明",
                        "value": [
                            {
                                "name": "是否含VAT",
                                "value": "是"
                            },
                            {
                                "name": "是否含城市税",
                                "value": "否8.13/人"
                            },
                            {
                                "name": "报价含早餐",
                                "value": "2份"
                            }
                        ]
                    },
                    {
                        "name": "使用说明",
                        "value": [
                            {
                                "name": "抵达酒店后",
                                "value": "用您的预定时提供的证件 以及 voucher (预定凭证) 即可入驻"
                            }
                        ]
                    },
                    {
                        "name": "退改说明",
                        "value": [
                            {
                                "name": "退改政策",
                                "value": "有条件取消"
                            },
                            {
                                "name": "",
                                "value": "使用前30天18:00可免费取消100%"
                            }
                        ]
                    }
                ],//productName为城市稅不显示
            }
        ]
    },
    //订单信息
    orderListResult: {
        createName: "karen",//下单人
        orderChildrenId: '1899721130253205506',
        stateName: '酒店',
        //购买的商品信息
        orderListDetailResultList: [
            {
                "cancelNumber": 12,//取消数量
                "currency": "€",
                "endTime": "2025.05.06",
                "id": "1899721130404200449",
                "number": 6,
                "price": 120,
                "priceCompany": "间",
                "productName": "Double for single",
                "productNameEn": "",
                "rate": 7.7626,
                "remark": "",
                "startTime": "2025.05.05",
                "stockId": "1899358520513118210",
                "totalPrice": 5589.072,
                "useTime": "晚"
            }
        ],
        truncationResult: {
            "brushPosition": "",
            "childrenId": "",
            "client": "",
            "companyId": null,
            "content": "",
            "lock": 0,
            "opButtonResultList": [
                {
                    "buttonBackgroundColor": "",
                    "buttonColor": "",
                    "buttonName": "再次预定",
                    "buttonPermissions": "",
                    "functionName": "reorder"
                }
            ],
            "opLogResults": [
                {
                    "createTime": "2025-03-12 15:16:27",
                    "remark": "<span>您已于<span style='color: rgb(221, 88, 39);'>2025-03-12 15:16:27</span>提交订单 （订单将在*后关闭），请尽快支付</span>"
                },
                {
                    "createTime": "2025-03-12 15:16:48",
                    "remark": "<span>您已于<span style='color: rgb(221, 88, 39);'>2025-03-12 15:16:48</span>支付订单</span>"
                },
                {
                    "createTime": "2025-03-24 12:49:08",
                    "remark": "<span>您已于<span style='color: rgb(221, 88, 39);'>2025-03-24 12:49:08取消订单  询佳-询好价 </span>期待为您提供下一次的服务~</span>"
                },
                {
                    "createTime": "2025-03-24 12:49:08",
                    "remark": "<span>询佳已于<span style='color: rgb(221, 88, 39);'>2025-03-24 12:49:08 退款成功</span> 询佳-询好价 期待为您提供下一次的服务~</span>"
                }
            ],
            "orderDescription": "",
            "remark": "<span>询佳已于<span style='color: rgb(221, 88, 39);'>% 退款成功</span> 询佳-询好价 期待为您提供下一次的服务~</span>",
            "seconds": null,
            "statusResultList": [
                {
                    "childrenId": "1899721130303537153",
                    "companyId": 1,
                    "createTime": 1741763808000,
                    "highlight": 1,
                    "id": 97853,
                    "serialNumber": 1,
                    "statusName": "TO_BE_PAID",
                    "statusText": "已支付",
                    "system": 0
                },
                {
                    "childrenId": "1899721130303537153",
                    "companyId": 1,
                    "createTime": 1741763808000,
                    "highlight": 1,
                    "id": 97854,
                    "serialNumber": 2,
                    "statusName": "CONFIRMING",
                    "statusText": "待确认",
                    "system": 0
                },
                {
                    "childrenId": "1899721130303537153",
                    "companyId": 1,
                    "createTime": 1741763787000,
                    "highlight": 0,
                    "id": 97855,
                    "serialNumber": 3,
                    "statusName": "WAITING_FOR_TRAVEL",
                    "statusText": "待出行",
                    "system": 0
                },
                {
                    "childrenId": "1899721130303537153",
                    "companyId": 1,
                    "createTime": 1741763787000,
                    "highlight": 0,
                    "id": 97856,
                    "serialNumber": 4,
                    "statusName": "TO_BE_COMMENTED_ON",
                    "statusText": "待点评",
                    "system": 0
                },
                {
                    "childrenId": "1899721130303537153",
                    "companyId": 1,
                    "createTime": 1741763787000,
                    "highlight": 0,
                    "id": 97857,
                    "serialNumber": 5,
                    "statusName": "COMPLETED",
                    "statusText": "已完成",
                    "system": 0
                },
                {
                    "childrenId": "1899721130303537153",
                    "companyId": null,
                    "createTime": 1742791748000,
                    "highlight": 1,
                    "id": 98560,
                    "serialNumber": 6,
                    "statusName": "CANCEL_UNPAID",
                    "statusText": "订单取消(已支付)",
                    "system": 0
                },
                {
                    "childrenId": "1899721130303537153",
                    "companyId": null,
                    "createTime": 1742791748000,
                    "highlight": 1,
                    "id": 98563,
                    "serialNumber": 7,
                    "statusName": "FAILED_AND_REFUNDED",
                    "statusText": "已退款",
                    "system": 0
                }
            ],
            "system": "",
            "userId": null
        }
    },
}